import React, { useState } from "react";
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import AthleteSidebar from "./AthleteSidebar";
import AthleteSecondarySidebarPanel from "./AthleteSecondarySidebarPanel";
import { isAthlete, isGuardian } from "../utils/auth";
import "../styles/athlete-admin-layout.css";
import "../styles/athlete-admin-secondary-sidebar.css";
import "../styles/athlete-admin-scaled-wrapper.css";
import "../styles/athlete-admin-page-spacing.css";

/**
 * AthleteAdminLayout - Layout wrapper for athlete pages when viewed by admin/coach
 *
 * This component wraps athlete pages and conditionally renders the AthleteSidebar
 * when an admin/coach is viewing an athlete's page (detected by athleteId param).
 *
 * By placing the sidebar at this layout level instead of in each individual page,
 * we prevent the sidebar from re-rendering on every navigation between athlete pages.
 */
export default function AthleteAdminLayout() {
    const { athleteId } = useParams();
    const parentContext = useOutletContext();
    const isAdminViewingAthlete = !isAthlete() && !isGuardian() && athleteId;
    const [secondarySidebarCollapsed, setSecondarySidebarCollapsed] = useState(false);

    if (isAdminViewingAthlete) {
        // Admin/coach viewing athlete pages - show athlete sidebar
        return (
            <div
                className={
                    secondarySidebarCollapsed
                        ? "athlete-admin-view athlete-secondary-sidebar-collapsed"
                        : "athlete-admin-view"
                }
            >
                <div className="page-layout">
                    <div className="athlete-secondary-sidebar-slot">
                        <AthleteSecondarySidebarPanel
                            collapsed={secondarySidebarCollapsed}
                            onToggle={() => setSecondarySidebarCollapsed((prev) => !prev)}
                        >
                            <AthleteSidebar variant="admin-secondary" />
                        </AthleteSecondarySidebarPanel>
                    </div>
                    <div
                        className={
                            secondarySidebarCollapsed
                                ? "page-content with-athlete-sidebar athlete-page-content-expanded"
                                : "page-content with-athlete-sidebar"
                        }
                    >
                        <Outlet context={parentContext} />
                    </div>
                </div>
            </div>
        );
    }

    // Athlete viewing their own pages or guardian viewing - no secondary sidebar needed
    return <Outlet context={parentContext} />;
}

